import { signOut } from 'firebase/auth';
import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../../firebase.init';
import hand from '.././../../images/nav-logo.png';
import { NavLink } from 'react-router-dom';
import './Banner.css';
const Banner = () => {

    return (
        <div>
            <section className="Bg_img">
                <div>
                    <img src={hand} className="mx-auto pt-7" style={{ height: '100px' }} alt="" />
                    <h1 data-aos="flip-up" className='text-6xl font-semibold text-center text-white lg:pt-7 banner_text'>Lorem ipsum dolor sit Lorem  <br /> ipsum dolor sit amet.</h1>
                    <div className='flex justify-center'>
                        <button className='mt-6 btn btn-primary rounded-none text-white'>Learn More  → </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Banner;